/*
TMA/TME GERAL
*/

import React, { useEffect } from 'react';
// import { HorizontalBar } from 'recharts';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Cell, LabelList, ResponsiveContainer, Rectangle } from 'recharts';
import { useState } from 'react';
import { api_bd_nr } from '../../services/Api';
import { msToTime } from '../../util/fns';



const CustomBarChart = ({
    chartData,
    CustomTick_XAxis,
    CustomTick_YAxis,
    CustomTooltip,
    barheight,
    renderCustomLabel,
    renderCustomBarLabel,
    prefix = 'TME: ',
    dataKey_X = 'tme',
    dataKey_Y = 'name',
    title = 'TME',
    cardHeight = 500
}) => {

    // chartData = chartData.sort((a, b) => b[dataKey_X] - a[dataKey_X])
    chartData = chartData?.length > 0
        ? [...chartData].sort((a, b) => b?.[dataKey_X] - a?.[dataKey_X]) // Create a copy before sorting
        : [];

    return (
        <div style={{ width: '100%', maxWidth: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }} >
            <span style={{ marginTop: 20, marginBottom: 10, fontSize: '1.3em', fontWeight: 'bold' }}>{title}</span>
            <div style={{
                display: 'flex',
                width: '100%',
                height: cardHeight
            }}>
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart
                        data={chartData}
                        layout="vertical"
                        margin={{
                            top: 20,
                            right: 20,
                            left: 90,
                            bottom: 5
                        }}
                    >

                        <CartesianGrid
                        // strokeDasharray="1 1" 
                        />

                        <XAxis
                            type="number"
                            tick={CustomTick_XAxis}
                            dataKey={dataKey_X}
                        />
                        <YAxis
                            dataKey={dataKey_Y}
                            type="category"
                            tick={CustomTick_YAxis}
                        />
                        <Tooltip content={<CustomTooltip prefix={prefix} />} />
                        <Bar
                            radius={[0, 5, 5, 0]}
                            dataKey={dataKey_X}
                            barSize={barheight}
                            label={renderCustomBarLabel}
                        >
                            {chartData.map((entry, index) => (
                                //Configuração da barra
                                <Cell key={`cell-${index}`} fill="#0C50DA" />
                            ))}
                            <LabelList dataKey="value" content={renderCustomLabel} />
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    )
}



const TME_TMA = ({ periodo = false }) => {
    const [chartData, setChartData] = useState([
        { label: "analista 1", tma: 0, tme: 0 },
        // Mais dados conforme necessário
    ]);

    const maintainAspectRatio = false
    const fontSizeYaxis = 19
    const fontSizeXaxis = 13
    const fontSizeBar = 14
    const fontSizeToolTip = 16
    const chartHeight = 500//380
    const barheight = 50//100
    const cardWidth = '49%'

    const  truncateString = (str, maxLength) => {
        if (str.length > maxLength) {
            return str.slice(0, maxLength - 3) + "...";
        }
        return str;
    }

    const renderCustomLabel = (props) => {
        const { x, y, width, height, value } = props;
        const textColor = '#000'//'white'//value > 41 ? 'white' : '#000';
        return (
            <text x={x + width / 2} y={y + height / 2} dy={5} fill={textColor} textAnchor="middle" font-weight="bold" font-size="smaller">
                {value}
            </text>
        );
    };

    const CustomTick_YAxis = (props) => {
        // console.log(Object.keys(props), 'height::   ' + props.height, props)
        const { x, y, payload, height, width } = props;

        return (
            <g transform={`translate(${x},${y})`}>
                <text
                    x={0}
                    y={0 - chartData.length}
                    dy={16}
                    textAnchor="end"
                    verticalAnchor="middle"
                    fill="#666"
                    // font-size="6px"
                    style={{ fontSize: `${fontSizeYaxis}px` }}
                >
                    {truncateString(payload.value, 16)}
                </text>
            </g>
        );
    };

    const CustomTick_XAxis = (props) => {
        // console.log(Object.keys(props), 'height::   ' + props.height, props)
        const { x, y, payload, height, width } = props;

        const time = msToTime(payload.value)

        return (
            <g transform={`translate(${x},${y})`}>
                <text
                    x={0}
                    y={0}
                    dy={16}
                    textAnchor="middle"
                    // verticalAnchor="middle"
                    fill="#666"
                    // font-size="6px"
                    style={{ fontSize: `${fontSizeXaxis}px` }}
                >
                    {`${time.horas}:${time.minutos}`}
                </text>
            </g>
        );
    };

    const CustomTooltip = ({ active, payload, label, prefix = '' }) => {
        if (active && payload && payload.length) {
            const time = msToTime(payload[0].value)
            return (
                <div className="custom-tooltip" style={{ backgroundColor: '#fff', borderRadius: 5, padding: '10px', border: '1px solid #ccc' }}>
                    <p className="label" style={{ fontSize: fontSizeToolTip }}>{label}</p>
                    <p className="value" style={{ fontSize: fontSizeToolTip }}>{`${prefix}${time.horas}:${time.minutos}:${time.segundos}`}</p>
                    {/* <p className="value">{`Pontuação: ${payload[0].value}`}</p> */}
                    {/* Customize further as needed */}
                </div>
            );
        }

        return null;
    };

    const renderCustomBarLabel = ({ x, y, width, height, index, value }) => {
        const textColor = '#000';
        const time = msToTime(value)
        return (
            <text
                x={x + 5} //{x + width / 2}
                y={y + height / 2}
                dy={5}
                fill={textColor}
                // stroke="#fff"
                // stroke-width="0.1px"
                // textAnchor="middle"
                // textAnchor="end"
                font-weight="bold"
                style={{ fontSize: `${fontSizeBar}px` }}
            >
                {`${time.horas}:${time.minutos}:${time.segundos}`}
            </text>
        );
    };

    const getPeriod = (_period) => {
        const date = new Date(`${_period.ano}-${String((parseInt(_period.mes) + 1)).padStart(2, '0')}-01 00:00:00`);
        const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        return ({
            ds: `${firstDay.toLocaleDateString('en-CA')}`,
            de: `${lastDay.toLocaleDateString('en-CA')}`
        })
    }

    const processData = async (ds, de) => {
        const databd = (ds && de) ? await api_bd_nr(`/reports/gettm/${ds}/${de}`) : { data: {} } ;
        // console.log(databd.data)
        if (Object.keys(databd?.data?.actualMonth).length > 0) {
            const arrData = Object.values(databd.data.actualMonth).sort((a, b) => b.mtme - a.mtme).filter(el => 'name' in el)
            // console.log('arrData: ', arrData)

            setChartData(arrData.map((item, index) => ({
                name: item.name,
                tma: item.mtma,
                tme: item.mtme,
                key: `bar-${index}`
            })))
        }

    };

    // useState(() => processData(ds, de), [data]);

    useEffect(() => {
        (async () => {
            const { ds, de } = periodo ? getPeriod(periodo) : { ds: false, de: false }
            await processData(ds, de)
        })()
    }, [periodo?.mes, periodo?.ano])

    // console.log(periodo)
    // console.log('getPeriod', getPeriod(periodo))

    const propsChartTME = {
        chartData,
        CustomTick_XAxis,
        CustomTick_YAxis,
        barheight,
        renderCustomLabel,
        renderCustomBarLabel,
        CustomTooltip,
        prefix: 'TME: ',
        dataKey_X: 'tme',
        title: 'TME',
        cardHeight: chartHeight
    }

    const propsChartTMA = {
        chartData,
        CustomTick_XAxis,
        CustomTick_YAxis,
        barheight,
        renderCustomLabel,
        renderCustomBarLabel,
        CustomTooltip,
        prefix: 'TMA: ',
        dataKey_X: 'tma',
        title: 'TMA',
        cardHeight: chartHeight
    }


    return (
        // <div style={{ display: 'flex', flexDirection: 'row', width: '100%', height: chartHeight }}>
        <>
            <div className='card' style={{ width: cardWidth, maxWidth: cardWidth, display: 'flex', flexDirection: 'column' }}>
                <CustomBarChart
                    {...propsChartTME}
                />
            </div>

            <div className='card' style={{ width: cardWidth, maxWidth: cardWidth, display: 'flex', flexDirection: 'column' }}>
                <CustomBarChart
                    {...propsChartTMA}
                />
            </div>
        </>
    );
};

export default TME_TMA;